import { globalStore, toRaw } from "@/BaseComponent";

export const setOption = (chartOption: any) => {
    const selectOption = toRaw(chartOption);
    const global = globalStore();
    const Cdata = selectOption.data;

    let legendConfig = {};
    switch (selectOption.legendPosition) {
        case "left":
            legendConfig = {
                left: "left",
                top: "center",
                orient: "vertical",
            };
            break;
        case "bottom":
            legendConfig = {
                left: "center",
                top: "bottom",
                orient: "horizontal",
            };
            break;
        case "top":
            legendConfig = {
                left: "center",
                top: "top",
                orient: "horizontal",
            };
            break;
        case "none":
            legendConfig = { show: false };
            break;
        default:
            legendConfig = { show: true, orient: "horizontal", type: "scroll" };
            break;
    }

    let chartData = [] as Array<any>;
    switch (global.chart) {
        case "line":
            if (Cdata.legend.length > 1) {
                chartData = Cdata.legend.map((name: string, idx: number) => ({
                    name: name,
                    type: "line",
                    data: Cdata.data.map((data: any[]) => data[idx]),
                    symbolSize: 8,
                    label: {
                        show: true,
                        position: "top",
                        offset: [0, 5],
                        fontSize: 13
                    },
                }));
            } else {
                chartData = Cdata.data.map((data: any, idx: number) => ({
                    name: Cdata.legend[idx],
                    type: global.chart,
                    symbolSize: 8,
                    data: [data[2]],
                    label: {
                        show: true,
                        position: "top",
                            fontSize: 13,
                    },
                }));
            }
            break;
        case "bar":
            if (Cdata.data.length > 1) {
                chartData = Cdata.legend.map((item: string, idx: number) => ({
                    name: item,
                    type: "bar",
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    data: Cdata.data[idx],
                }));
            } else {
                chartData = [
                    {
                        data: Cdata.data[0],
                        type: "bar",
                        label: {
                            show: true,
                            formatter: "{b}\n{c}",
                            fontSize: 25,
                        },
                    },
                ];
            }
            break;
        case "pie":
            if (Cdata.data.length > 1) {
                chartData = Cdata.category.map((item: string, index: number) => ({
                    name: item, 
                    type: "pie",
                    center: [index * 18 + 15 + "%", "50%"],
                    radius: "30%",
                    data: Cdata.legend.map((subItem: string, subIndex: number) => ({
                        name: subItem,
                        value: Cdata.data[index][subIndex],
                    })),
                }));
            } else {
                chartData = [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: "55%",
                        symbolSize: 8,
                        data: Cdata.legend.map((data: any, idx: number) => ({ value: Cdata.data[0][idx], name: data })),
                        emphasis: {
                            label: {
                                formatter: "{b}: {c}",
                                position: "inside",
                                fontSize: 20,
                            },
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                        lavelLayout: {},
                        label: {
                            show: true,
                            position: "outside",
                        },
                    },
                ];
            }
            break;
        case "donut":
            if (Cdata.data.length > 1) {
                chartData = Cdata.category.map((item: string, index: number) => ({
                    name: item,
                    type: "pie",
                    center: [index * 18 + 15 + "%", "50%"],
                    radius: ["10%", "30%"],
                    data: Cdata.legend.map((subItem: string, subIndex: number) => ({
                        name: subItem,
                        value: Cdata.data[index][subIndex],
                    })),
                }));
            } else {
                chartData = [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: ["30%", "55%"],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: "#fff",
                            borderWidth: 2,
                        },
                        label: {
                            show: true,
                            position: "left",
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: "bold",
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        data: Cdata.legend.map((data: Array<Array<number>>, idx: number) => ({
                            value: Cdata.data[0][idx],
                            name: data,
                        })),
                    },
                ];
            }
            break;
        case "candle":
            chartData = [
                {
                    name: Cdata.legend,
                    type: "candlestick",
                    data: Cdata.data.map(([min, avg, max]: number[]) => [min, max, min, avg]),
                    itemStyle: {
                        color: "green",
                        color0: "red",
                        borderColor: "green",
                        borderColor0: "red",
                    },
                },
            ]
            break;
        default:
            break;
    }

    const defaultOption = {
        xAxis: {
            show: true,
            type: "category",
            data: global.chart === "candle" ? Cdata.legend : Cdata.category,
            axisLabel: {
                rotate: -45,
                fontSize: 10
            }
        },
        yAxis: {
            type: "value",
        },
        grid: {
            left: '10%',
            right: '10%',
            top: '15%',
            bottom: '30%'
        },
        title: {
            text: selectOption.title || "",
            subtext: selectOption.subTitle || null,
            padding: selectOption.titlePadding.length === 0 ? 3 : selectOption.titlePadding,
        },
        tooltip: global.chart !== "candle"? {
            trigger: "item",
            formatter: "{a} {b} {c}",
        }:{
            trigger: "axis",
            formatter: (params: any) => {
                const data = params[0].data;
                return `Date: ${params[0].axisValueLabel}<br>
                        avg: ${data[4]}`

            },
        },
        toolbox:
            global.chart === "bar"
                ? {
                      show: true,
                      orient: "vertical",
                      left: "right",
                      top: "center",
                      feature: {
                          mark: { show: true },
                          magicType: { show: true, type: ["line", "bar", "stack"] },
                          restore: { show: true },
                          saveAsImage: { show: true },
                      },
                  }
                : {},
        legend:{
            ...legendConfig,
            type: "scroll",
            selectedMode: "multiple", 
            data: Cdata.legend,
        },
        series: chartData,
    };
    

    return defaultOption;
};
